export default __webpack_public_path__ + "static/media/chip-cancel.c5696d5f.svg";